module.exports = __webpack_public_path__ + "static/media/achievement-ultimate-ace.7d4193f9.svg";